//@flow

export const addOnResumeListener = (listener: () => void) => {
  window.addEventListener('focus', listener);
};



// WEBPACK FOOTER //
// ./src/utils/appstate.js